// Live Google Play stats for our apps, fetched at build time into playStats.json.
// Re-fetch by running: python3 scripts/fetch_play_stats.py (see scripts/).
import rawStats from "./playStats.json";

export interface AppStat {
  package: string;
  rating: number | null;
  ratingCount: number | null;
  installs: string | null; // Play bucket, e.g. "5K+"
  notLive?: boolean;
}

export const playStats: Record<string, AppStat> = rawStats as Record<string, AppStat>;

export const statFor = (appId: string): AppStat | undefined => playStats[appId];

// Apps removed/suspended on Play — never show install CTAs or list publicly.
export const isLiveOnPlay = (appId: string): boolean => !playStats[appId]?.notLive;

// Only surface install counts that read as social proof.
export const installsLabel = (appId: string): string | null => {
  const s = playStats[appId];
  if (!s?.installs) return null;
  const m = s.installs.match(/^([\d.,]+)([KM]?)/);
  if (!m) return null;
  const n = parseFloat(m[1].replace(/,/g, "")) * (m[2] === "M" ? 1e6 : m[2] === "K" ? 1e3 : 1);
  return n >= 500 ? `${s.installs.replace(/\+?$/, "+")} downloads` : null;
};

// Show a star rating only when it's both real and flattering.
export const ratingLabel = (appId: string): { rating: number; count: number } | null => {
  const s = playStats[appId];
  if (s?.rating && s.rating >= 4.0 && s.ratingCount) return { rating: s.rating, count: s.ratingCount };
  return null;
};

// Portfolio-level aggregates for the homepage trust strip (computed from real buckets).
export const PORTFOLIO = { downloads: "25,000+", avgRating: "4.5" };
